import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-select',
    standalone: false,
    templateUrl: './select.component.html',
    styleUrl: './select.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectComponent implements OnChanges {
    @Input({ required: false }) label = '';
    @Input({ required: false }) iconPath = '';
    @Input({ required: false }) iconPosition = {
        right: '',
        left: ''
    };
    @Input({ required: true }) placeholder = 'placeholder';
    @Input({ required: false }) value = '';
    @Input({ required: true }) required = false;
    @Input({ required: false }) control: FormControl = new FormControl();
    @Input({ required: false }) multiSelect = false;
    @Input({ required: true }) optionsList: any[] = [];
    @Input({ required: false }) displayName = '';
    @Input({ required: false }) getName = '';
    @Input({ required: false }) disabled = false;
    @Input({ required: false }) isNoneRequired = false;

    @Output() afterSelectionChange = new EventEmitter<MatSelectChange>();
    @Output() afterIconClick = new EventEmitter<'left' | 'right'>();

    constructor(private translate: TranslateService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['value']) {
            this.control.patchValue(this.value);
        }
    }

    getErrorMessage() {
        if (this.control.hasError('required')) {
            return this.label ? `${this.translate.instant(this.label)} Is Required.` : 'Required Field';
        }
        return '';
    }
}
